import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BeneficiariesList, Beneficiary, BenefitBeneficiaryCard, SaveBeneficiariesPortalCriteria } from "src/app/models/beneficiary";
import { BeneficiariesService } from "src/app/services/beneficiaries.service";

@Component({
    selector: 'mwp-dialog-beneficiaries',
    templateUrl: './beneficiaries.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DialogBeneficiariesComponent implements OnInit {
    public displayForm: boolean;
    public benefitBeneficiaryCard: BenefitBeneficiaryCard;
    public beneficiariesList: BeneficiariesList;
    public isEdit: boolean = false;
    public isSelectBenefits: boolean = false;
    public isSave: boolean = false;
    public pendingBenefitBeneficiary: Beneficiary[];

    constructor(
        private beneficiariesService: BeneficiariesService,
        private dialogRef: MatDialogRef<DialogBeneficiariesComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
    ) {
    }

    ngOnInit(): void {
        this.isEdit = true;
        this.pendingBenefitBeneficiary = null;
        this.benefitBeneficiaryCard = this.dialogData.beneficiaryCard;
        this.beneficiariesList = this.dialogData.beneficiariesList;
    }

    public saveUpdatedBeneficiaries(data: Beneficiary[]): void {
        this.isEdit = false;
        this.isSelectBenefits = true;
        this.pendingBenefitBeneficiary = data;
    }

    public saveAndCloseDialog(data: number[]): void {
        const l_payload: SaveBeneficiariesPortalCriteria = new SaveBeneficiariesPortalCriteria();
        for (let beneficiary of this.pendingBenefitBeneficiary) {
            if (beneficiary.isSelected === true) {
                l_payload.beneficiaries.push(beneficiary);
            }
        }
        l_payload.memberBenefitIDs = data;
        this.beneficiariesService.saveBeneficiaries(l_payload).subscribe(() => {
            this.dialogRef.close({ dialogResult: data });
        });
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}